import { createAsyncThunk } from "@reduxjs/toolkit";
import { auth, db } from "../../firebase/config";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { doc, serverTimestamp, setDoc } from "firebase/firestore";

interface IAuth {
  email: string;
  password: string;
  fullName: string;
}

interface ISignUpResponse {
  userName: string;
  token: string;
  message: string;
  userEmail: string;
  uid: string;
}

interface IRejectValue {
  message: string;
}

export const signUp = createAsyncThunk<
  ISignUpResponse,
  IAuth,
  { rejectValue: IRejectValue }
>("auth/signUp", async (data, thunkAPI) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(
      auth,
      data.email,
      data.password
    );
    const user = userCredential.user;

    const userData = {
      fullName: data.fullName,
      email: data.email,
      createdAt: serverTimestamp()
    };

    await setDoc(doc(db, "users", user.uid), userData);

    return {
      userName: data.fullName,
      token: await user.getIdToken(),
      message: "User created successfully",
      userEmail: data.email,
      uid: user.uid
    };
  } catch (error) {
    return thunkAPI.rejectWithValue({ message: "Something went wrong" });
  }
});
